<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 添加结构化数据
    this.addStructuredData()
  },
  methods: {
    addStructuredData() {
      // 移除现有的结构化数据（如果存在）
      const existingScript = document.querySelector('script[type="application/ld+json"]#structured-data')
      if (existingScript) {
        existingScript.remove()
      }

      // 创建新的结构化数据脚本
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.id = 'structured-data'
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "武汉飞凌越智能科技有限公司",
        "alternateName": "飞凌越智能",
        "url": "https://www.feilingyue.com",
        "logo": "https://www.feilingyue.com/logo_1.ico",
        "description": "专注于智能控制与智能制造技术研发、生产，为用户提供自动化应用解决方案",
        "foundingDate": "2023",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "武汉",
          "addressRegion": "湖北省",
          "addressCountry": "CN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "",
          "contactType": "customer service"
        },
        "sameAs": [
          // 可以添加社交媒体链接
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "产品和服务",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "机器人控制系统",
                "description": "工业机器人、协作机器人控制系统解决方案"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "机器视觉应用",
                "description": "机器视觉算法开发和应用方案供应"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "移动机器人",
                "description": "无人导航算法和移动机器人设计、研发及制造"
              }
            }
          ]
        }
      })

      // 将脚本添加到head中
      document.head.appendChild(script)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
